import * as yup from 'yup'
import {
  RfpLaneCarrierRateCreateRequest,
  RfpLaneCarrierRateUpdateRequest,
} from '../apiTypes/requestForProposalLaneCarrierRates'

export interface IRFPLaneFormUpdateValidator
  extends Omit<
    RfpLaneCarrierRateUpdateRequest['rfpLaneCarrierRate'],
    'minCapacity' | 'maxCapacity'
  > {}
export interface IRFPLaneFormCreateValidator
  extends Omit<
    RfpLaneCarrierRateCreateRequest['rfpLaneCarrierRate'],
    'minCapacity' | 'maxCapacity'
  > {}

export const EditRateCardSchema = yup.object<RfpLaneCarrierRateUpdateRequest['rfpLaneCarrierRate']>(
  {
    carrierApplicationId: yup.string().required('A carrier is required'),
    canDoWeekends: yup.boolean(),
    confirmed: yup.boolean(),
    minCapacity: yup.number().nullable(),
    maxCapacity: yup.number().nullable(),
    rateAttributes: yup.object({
      id: yup.string(),
      amount: yup.string().required('A rate amount is required'),
      rateTypeKey: yup.string().required('A rate type key is required'),
    }),
  }
)

export const AddRateCardSchema = yup.object<RfpLaneCarrierRateCreateRequest['rfpLaneCarrierRate']>({
  carrierApplicationId: yup.string().required('A carrier is required'),
  canDoWeekends: yup.boolean(),
  confirmed: yup.boolean(),
  minCapacity: yup.number().nullable(),
  maxCapacity: yup.number().nullable(),
  rateAttributes: yup.object({
    amount: yup.string().required('A rate amount is required'),
    rateTypeKey: yup.string().required('A rate type key is required'),
  }),
  requestForProposalLaneId: yup.string(),
})
